import { render } from "./EmailVerifiedDoc.vue?vue&type=template&id=3a11e552&ts=true"
import script from "./EmailVerifiedDoc.vue?vue&type=script&lang=ts"
export * from "./EmailVerifiedDoc.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__